// Fetches and caches the latest daily FX rate for a currency pair (see
// doc/sweden-expansion-currency-plan.md, "FX / Exchange Rate Management"). Backed by
// api/currencyrate/latest/{from}/{to}, which reads the currency_rate table populated by the
// currencyratefetcher Lambda. Display-only use (e.g. converting a EUR catalog price to a SEK
// tenant's currency in the location editor) -- never used for transactional conversion, which
// happens server-side at order/invoice creation time.
import Ajax from './ajax';

export const FETCH_EXCHANGE_RATE_REQUESTED = 'currencyratedata/FETCH_EXCHANGE_RATE_REQUESTED';
export const FETCHED_EXCHANGE_RATE = 'currencyratedata/FETCHED_EXCHANGE_RATE';
export const FETCH_EXCHANGE_RATE_FAILED = 'currencyratedata/FETCH_EXCHANGE_RATE_FAILED';

export const rateKey = (fromCurrency, toCurrency) => `${fromCurrency}_${toCurrency}`;

const initialState = {
    ratesByPair: {}, // key -> { rate, rateDate }
    fetchingPairs: {}, // key -> true while a fetch is in flight
};

export default (state = initialState, action) => {
    switch (action.type) {
        case FETCH_EXCHANGE_RATE_REQUESTED:
            return { ...state, fetchingPairs: { ...state.fetchingPairs, [action.key]: true } };
        case FETCHED_EXCHANGE_RATE:
            return {
                ...state,
                fetchingPairs: { ...state.fetchingPairs, [action.key]: false },
                ratesByPair: {
                    ...state.ratesByPair,
                    [action.key]: { rate: action.rate, rateDate: action.rateDate },
                },
            };
        case FETCH_EXCHANGE_RATE_FAILED:
            return { ...state, fetchingPairs: { ...state.fetchingPairs, [action.key]: false } };
        default:
            return state;
    }
};

// No-ops if the pair is identity (same currency, rate is trivially 1) or already cached/in flight --
// safe to call on every render of a component that needs a rate.
export const getExchangeRate = (fromCurrency, toCurrency) => {
    return async (dispatch, getState) => {
        if (!fromCurrency || !toCurrency || fromCurrency === toCurrency) return;
        const key = rateKey(fromCurrency, toCurrency);
        const state = getState().currencyratedata || initialState;
        if (state.ratesByPair[key] || state.fetchingPairs[key]) return;
        dispatch({ type: FETCH_EXCHANGE_RATE_REQUESTED, key });
        try {
            const resp = await Ajax.get(`api/currencyrate/latest/${fromCurrency}/${toCurrency}`);
            dispatch({
                type: FETCHED_EXCHANGE_RATE,
                key,
                rate: resp.data ? resp.data.rate : null,
                rateDate: resp.data ? resp.data.rateDate : null,
            });
        } catch (err) {
            dispatch({ type: FETCH_EXCHANGE_RATE_FAILED, key });
        }
    };
};
